import { h } from 'preact';
import { findInVNode } from 'utils/vnode';
import * as BaseComp from 'base/bolt/boltApp.js';

import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {
	// async componentDidMount(...args) {
	// 	super.componentDidMount?.(...args);

	// }

	renderMain(props, state) {
		const base = super.renderMain(props, state);
		const searchData = state?.appState?.search || {};
		const headerComp = findInVNode(base, '[key="header"]');

		if (headerComp?.attributes) {
			headerComp.attributes.searchData = searchData;
		}
		return base;
	}

	getH1(appData, page, activePageDetails, activePage) {

		let fullPageName = super.getH1(appData, page, activePageDetails, activePage);

		// const headerTagline = appData?.header?.curzonHeader?.logo.text;

		if (activePageDetails?.h1) {
			fullPageName = activePageDetails.h1;
		} else if (activePageDetails.type === 'filmPage') {
			fullPageName = Object.values(activePageDetails.data || {}).find(page => page.component === 'heroSpot')?.data?.title;
		} else {
			fullPageName = 'Curzon Film';
		}

		return <h1 class={s.pageName}>{fullPageName}</h1>;
	}
}
